import { useEffect, useState } from "react";
import TextInputClearable from "./text-input-clearable";
import { Button } from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";
import { SwitchField } from "@aws-amplify/ui-react";
import SmartSelect from "./smart-select";
import { FloatingLabel, Form } from "react-bootstrap";
const EditExerciseForm = ({ element, onSave, createNewForm }) => {

    const [name, setName] = useState(element?.name || "")
    const [description, setDescription] = useState(element?.description || "")
    const [isFavorite, setIsFavorite] = useState(element?.favorite || false)
    const [muscleGroup, setMuscleGroup] = useState(element?.group || "")
    const [picture, setPicture] = useState(element?.picture || "")
    const [day, setDay] = useState(element?.day || "Day 1")
    const navigate = useNavigate()

    useEffect(() => {
        setName(element?.name || "")
        setDescription(element?.description || "")
        setIsFavorite(element?.favorite || false)
        setMuscleGroup(element?.group || "")
        setPicture(element?.picture || "")
        setDay(element?.day || "Day 1")
    }, [element])

    return (
        <div className="text-align-start">
            <div className="d-flex">
                <h4>{createNewForm ? "Add New Exercise" : "Edit Exercise"}</h4>
            </div>
            <div >
                <TextInputClearable
                    controlId={`name-${element?.id}`}
                    label="Name"
                    value={name}
                    onValueChanged={(e) => { setName(e) }}
                    placeholder="Exercise name"
                    maxLength={120}
                    minLength={3}
                    isLoading={false} />

            </div>
            <div>
                <FloatingLabel label="Description" controlId="description" className="my-1 w-100">
                    <Form.Control
                        as="textarea"
                        value={description}
                        maxLength={500}
                        onChange={(e) => {

                            setDescription(e.target.value)
                        }}
                        placeholder="Description"
                        style={{ height: '6rem' }}
                    />
                </FloatingLabel>
            </div>

            <div>
                <SmartSelect
                    value={muscleGroup}
                    minLength={2}
                    maxLength={50}
                    onValueChanged={(e) => {
                        setMuscleGroup(e)
                    }}
                    label="Muscle group">
                    <option value="Chest" aria-label="Chest" />
                    <option value="Back" aria-label="Back" />
                    <option value="Shoulders" aria-label="Shoulders" />
                    <option value="Biceps" aria-label="Biceps" />
                    <option value="Triceps" aria-label="Triceps" />
                    <option value="Quads" aria-label="Quads" />
                    <option value="Core" aria-label="Core" />
                    <option value="Calves" aria-label="Calves" />
                </SmartSelect>
            </div>
            <div>
                <SmartSelect
                    value={day}
                    minLength={2}
                    maxLength={50}
                    onValueChanged={(e) => {
                        setDay(e)
                    }}
                    label="Day">
                    <option value="Day 1" aria-label="Day1" />
                    <option value="Day 2" aria-label="Day2" />
                    <option value="Day 3" aria-label="Day3" />
                </SmartSelect>
            </div>
            <div >
                <TextInputClearable
                    controlId={`url-${element?.id}`}
                    label="Image Url"
                    value={picture}
                    onValueChanged={(e) => { setPicture(e) }}
                    placeholder="Image URL"
                    maxLength={256}
                    minLength={0}
                    info={"Image URL (any public picture or cloud storage like Google Drive, S3)"}
                    isLoading={false} />

            </div>

            <div className="mx-2">
                <SwitchField
                    isChecked={isFavorite}
                    isDisabled={false}
                    label="Favorite"
                    labelPosition="end"
                    onChange={(e) => {
                        setIsFavorite(e.target.checked);
                    }}
                />
            </div>

            <div className="d-flex align-items-center justify-content-end">
                <Button
                    loadingText=""
                    className="mx-1"
                    onClick={() => {
                        navigate(`/exercises/${element?.id}`)
                    }}
                >
                    Cancel
                </Button>
                <Button
                    variation="primary"
                    className="mx-1"
                    loadingText=""
                    onClick={() => {
                        const updatedElement = { ...element }
                        updatedElement.name = name
                        updatedElement.description = description
                        updatedElement.picture = picture
                        updatedElement.favorite = isFavorite
                        updatedElement.group = muscleGroup
                        updatedElement.day = day
                        onSave(
                            updatedElement
                        )
                    }
                    }
                >
                    Save
                </Button>
            </div>
        </div>
    )
}

export default EditExerciseForm;